import React, { Component } from 'react';
import PropTypes from 'prop-types';

import uuid from 'uuid/v4';
import 'icheck/skins/all.css'; // or single skin css
import { Radio, RadioGroup } from 'react-icheck';

class Checkbox extends Component {
  onChecked = (e) => this.props.onChange(e);

  render() {
    const {
      label,
      checked,
      onChange,
      name,
      data,
      state_unique = false,
      ...spreadProps
    } = this.props;

    return (
      <div>
        <p>{label}</p>
        <RadioGroup name={name} value={checked} onChange={this.onChecked}>
          {data.map((radio) => {
            if (!radio.state_unique || checked == radio.key)
              return (
                <Radio
                  value={radio.key}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label={radio.value}
                />
              );
            else return <Radio></Radio>; // Return radio empty, so it dont render.
          })}
        </RadioGroup>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// src/modules/common/components/form/Radio.js